import request from "@/utils/request";
import Qs from "qs";

const api = {
  findAllDepts: "/api/dept/findAllDepts",
  save: "/api/dept/save",
  update: "/api/dept/updateDeptStatus"
};

/**
 * 查询所有部门 tree
 * @param {*} parameter
 */
export function findAllDepts(parameter) {
  return request({
    url: api.findAllDepts,
    method: "get",
    params: parameter
  });
}

/**
 * 添加/修改部门
 * @param {*} parameter
 */
export function save(parameter) {
  return request({
    url: api.save,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

/**
 * 添加/修改部门
 * @param {*} parameter
 */
export function update(parameter) {
  return request({
    url: api.update,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
